module.exports = __webpack_public_path__ + "static/img/ban-2.a9428c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-2.jpg
// module id = zcnV
// module chunks = 0